import type { ImageColor } from "../model/types";

export const PROFILE_COLOR: Record<ImageColor, string> = {
  GREEN: "/assets/images/profile/profile-green.png",
  RED: "/assets/images/profile/profile-pink.png",
  BLUE: "/assets/images/profile/profile-blue.png",
  YELLOW: "/assets/images/profile/profile-yellow.png",
};
